import { render, staticRenderFns } from "./NotiItemDetail.vue?vue&type=template&id=6d5a6a36&scoped=true&"
import script from "./NotiItemDetail.vue?vue&type=script&lang=js&"
export * from "./NotiItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotiItemDetail.vue?vue&type=style&index=0&id=6d5a6a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a6a36",
  null
  
)

export default component.exports